import { useQuery } from '@tanstack/react-query';
import { IPublications, PublicationTypes } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useGetPublication = (type: PublicationTypes) => {
  return useQuery({
    queryKey: queryKeys.publications.details(type),
    queryFn: () => fetchPublication(type),
    staleTime: 0,
  });
};

const fetchPublication = async (
  type: PublicationTypes,
): Promise<IPublications> => {
  const url = `/getPublicationInfo?publication_type=${type}`;
  const response = await requestCCApi({ url });

  return response.data;
};
